<template>
  <el-dialog
      title="批量查找"
      v-model="batchVisible"
      destroy-on-close
      width="730"
      append-to-body
      :close-on-click-modal="false">
      <template v-if="batchVisible">
        <div class="content">
          <p v-if="notFoundNames.length === 0">请将姓名粘贴到以下的文本框中，姓名之间可以用逗号、顿号、分号或换行分隔。</p>
          <p v-else style="color: #FF0000;">没有找到以下姓名，请确认信息是否有误</p>
          <el-input
            type="textarea"
            :rows="11"
            v-model="nameVal">
          </el-input>
        </div>
        <span class="dialog-footer">
          <el-button @click="batchVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSumbit">确 定</el-button>
        </span>
      </template>
  </el-dialog>
</template>

<script>
  import { axiosBase } from '@/api/api'
  export default {
    name: "batchSearch",
    data() {
      return {
        batchVisible: false,
        nameVal: "",
        data:{},
        notFoundNames: [], // 未找到的姓名
        settingOrg: {}, // 组织配置
        detailInfo: {}, //明细控件配置
        channel: '', //是否通知对象点击进来
        linkedData: [] //联动数据
      }
    },
    methods: {
      fromParentMethod (item, detail, channel, linkedData) {
        this.data = item
        // this.settingOrg = {apiurl: item.apiurl, onlyUser: item.onlyUser, option: item.lookCustomArr, leaf: item.leafOrg, checkedArr: this.checkedFlowArr, radio: item.radio_ }
        if(detail){
          this.detailInfo = detail
        }        
        else{
          this.detailInfo = {}
        }
        if(channel){
          this.channel = channel
        }
        if(linkedData){
          this.linkedData = linkedData
        }
        this.notFoundNames = []
        this.nameVal = ''
        this.batchVisible = true
      },
      handleSumbit(){
        // 处理输入的姓名，将不同分隔符统一处理
        const inputNames = this.nameVal.split(/[,，、;；\n]/).map(name => name.trim()).filter(name => name);
        if(this.linkedData.length > 0){
          this.nameMatch(inputNames, this.linkedData)
          return
        }
        const obj = {
          curpage: 1,
          pagesize: 100,
          name: this.nameVal
        }
        if(this.data.lookRMSIsUser === 1 || this.data.lookRMSIsUser === 2){
					obj.orgtype = this.data.lookRMSIsUser
				}
				else if(this.data.lookRMSIsUser === 4 || this.channel === 'cto'){
					const list = typeof this.data.lookCustomArr === 'string'? JSON.parse(this.data.lookCustomArr) : this.data.lookCustomArr
					if(list && list.length > 0){
						let organizationsId = list.map(item => item.organizationId)
            // 联系人控件-部门查看范围-自定义（是否选择子部门,organizationIdss不包含下级）
            if((this.data && this.data.lookCustomChild) && (!this.channel || this.channel !== 'cto')){
              obj.organizationsId = organizationsId.join(',');
            }
            else{
              // 告知可搜索子部门
              if(this.channel || this.channel === 'cto'){
                obj.organizationsId = organizationsId.join(',');
              }
              else{
                obj.organizationIdss = organizationsId.join(',');
              }
            }
					}
				}
				if(this.data.lookRMSIsUserRole === 1){
					obj.roletype = 1
				}
				else if(this.data.lookRMSIsUserRole === 3 || this.channel === 'cto'){
					const list = typeof this.data.lookCustomArrRole === 'string' ? JSON.parse(this.data.lookCustomArrRole) : this.data.lookCustomArrRole
					if(list && list.length > 0){
						let roleId = list.map(item => item.roleId)
						obj.rolesId = roleId.join(',');
					}
        }
        if (this.data.userTag !== 0) {
          obj.type = this.data.userTag
        }
        axiosBase(obj,"/openapi/getuserlist").then(res => {//获取用户
          if(res.data.length>0){
            this.nameMatch(inputNames, res.data)
          }
          else{
            this.$message.warning("没有找到相关用户,请重新搜索")
          }          
        });
        // this.$emit('signetTemplateChild',this.data,this.templateId)
      },
      nameMatch(inputNames, userArr){
        // 找出未匹配的姓名
        const foundNames = userArr.map(user => user.realname);
        this.notFoundNames = inputNames.filter(name => !foundNames.includes(name));
        // 按照输入的姓名顺序重新排序用户数组，重复输入的名字会重复显示对应用户
        userArr = inputNames
          .filter(name => foundNames.includes(name))
          .flatMap(name => {
            // 找出该姓名对应的所有用户
            const sameNameUsers = userArr.filter(user => user.realname === name);
            // 如果有多个同名用户，则全部返回
            return sameNameUsers;
          });
                  
        if(this.data.singleIsUser === 0){
          userArr = userArr.slice(0, 1);
        }
        else if(this.data.singleIsUser === 1){
          userArr = userArr.slice(0, this.data.maxCount);
        }
        this.$emit('batchSearchChild', {user: userArr, data: this.data, detailInfo: this.detailInfo})
        if(this.notFoundNames.length > 0) {
          this.nameVal = this.notFoundNames.join('\n')
          return false;
        }
        this.batchVisible = false
      },
    }
  }
</script>

<style scoped lang="scss">
.el-dialog__header {
  border-bottom: 1px solid #ccc;
}
:deep(.el-dialog__body) {
  padding: 20px;  
}
.content {
  p {
    color: #333333;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 15px;
  }
}
.dialog-footer {
  display: flex;
  justify-content: right;
  padding-top: 20px;
}
</style>
